import { useMemo } from "react"

import { CreateOrderDialogType } from "../createOrderTypes"

export type CreateOrderDialogTypeFlags = Readonly<{
    isRefundOrder: boolean
    isRegularOrder: boolean
    isSpecialDialog: boolean
    isSupplementaryOrder: boolean
}>

export function getCreateOrderDialogTypeFlags(dialogType: CreateOrderDialogType): CreateOrderDialogTypeFlags {
    const isRegularOrder = dialogType === CreateOrderDialogType.ORDER
    const isRefundOrder = dialogType === CreateOrderDialogType.CREDIT_NOTE
    const isSupplementaryOrder = dialogType === CreateOrderDialogType.SUPPLEMENTARY_ORDER
    const isSpecialDialog = !isRegularOrder

    return { isRefundOrder, isRegularOrder, isSpecialDialog, isSupplementaryOrder }
}

export function useCreateOrderDialogType(dialogType: CreateOrderDialogType): CreateOrderDialogTypeFlags {
    return useMemo(() => getCreateOrderDialogTypeFlags(dialogType), [dialogType])
}
